// Price formatting utility
export const formatPrice = (price) => {
    if (!price && price !== 0) return 'Price not set';
    
    const numericPrice = parseFloat(price);
    if (isNaN(numericPrice)) return 'Invalid price';
    
    if (numericPrice === 0) return 'Free';
    
    // Format with Nigerian Naira symbol and commas
    return `₦${numericPrice.toLocaleString('en-NG')}`;
  };
  
  // Category mapping (same as RN)
  export const CATEGORY_TYPE_MAPPING = {
    12: 'electronics', // Computers & Laptops
    19: 'electronics', // Mobile Phones
    20: 'electronics', // Tablets
    22: 'electronics', // Smartwatches
    13: 'electronics', // TVs & Audio Systems
    14: 'electronics', // Cameras & Drones
    15: 'electronics', // Gaming Consoles
    
    85: 'services', // Repair & Maintenance
    86: 'services', // Home Cleaning & Laundry
    87: 'services', // Pest Control
    88: 'services', // Event Planning & Photography
    89: 'services', // Health & Fitness
    90: 'services', // Education & Tutoring
    91: 'services', // Logistics & Delivery
    92: 'services', // Business & Tech Services
    93: 'services', // Legal & Financial Services
    94: 'services', // Plumbing & Water Treatment
    
    24: 'vehicles', // Cars
    25: 'vehicles', // Motorcycles & Scooters
    26: 'vehicles', // Trucks & Trailers
    27: 'vehicles', // Buses & Vans
    30: 'vehicles', // Boats & Watercraft
    
    62: 'properties', // Houses for Sale
    63: 'properties', // Houses for Rent
    64: 'properties', // Land & Plots
    65: 'properties', // Commercial Property
    66: 'properties', // Short Let Apartments
    68: 'properties', // Office & Shop Spaces
    69: 'properties', // Hostels & Student Accommodation
  };
  
  export const getCategoryType = (categoryId) => {
    if (!categoryId) return 'default';
    
    const numericId = parseInt(categoryId);
    const directType = CATEGORY_TYPE_MAPPING[numericId];
    
    return directType || 'default';
  };
  
  // Check if condition should be shown (same logic as RN)
  export const shouldShowCondition = (categoryId) => {
    if (!categoryId) return true;
    
    const categoryType = getCategoryType(categoryId);
    const excludedCategoryTypes = ['services', 'properties'];
    
    return !excludedCategoryTypes.includes(categoryType);
  };
  
  // Format date
  export const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-NG', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      return '';
    }
  };
  
  // Format time ago
  export const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);
      
      if (diffInSeconds < 60) return 'just now';
      if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
      if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
      if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d ago`;
      
      return date.toLocaleDateString('en-NG', { month: 'short', day: 'numeric' });
    } catch (error) {
      return '';
    }
  };